<template>
  <div class="f-column">
    <UnSwitcherNew
      :hasText="true"
      :asMenu="false"
      :options="[{ payload: 'include' }, { payload: 'exclude' }]"
      :tab="exclude ? 'exclude' : 'include'"
      tstPrefix="suitsfiltr"
      style="--gwbtns-gap: 2px; --gwbtn-padding: 0 0.5rem; --gwbtn-clr-back: transparent"
      translatePath="tabs"
      @click="item => setIncex(item.payload)"
    />
    <div
      class="d-flex scroll-right-overlay"
      style="
        position: relative;
        min-width: 0;
        padding: 0 0.125rem;
        margin-top: 0.625rem;
        --clr-scrl-back: var(--clr-suitsfiltr-back);
        --scrl-width: 1rem;
      "
    >
      <div
        class="d-flex no-scroll-track"
        style="
          max-width: 100%;
          gap: 1rem;
          overflow-y: hidden;
          overflow-x: auto;
          padding: 0 1rem 0 0;
        "
        @wheel.stop="e => wheelScroll(e)"
      >
        <div class="suitsfiltr_cards suitsfiltr_offsuit">
          <div class="suitsfiltr_cards_title">
            {{ $t(`common.offsuited`) }}
          </div>
          <div class="suitsfiltr_cards_row">
            <div
              v-for="card in cards.offsuited"
              :key="card.value"
              class="mdi icon_btn suitsfiltr_cards_item"
              :data-tst="`offsuited_${card.value}`"
              :class="`
          ${
            isActive(card, 'offsuited', exclude)
              ? 'icon_btn_active suitsfiltr_cards_item_active'
              : ''
          }
          suit_${card.value} ${card.icon}${exclude ? '-outline' : ''}`"
              :style="`--clr-suit: var(${card.color})`"
              @click="setCard('offsuited', card.value)"
            ></div>
          </div>
        </div>

        <div class="suitsfiltr_cards suitsfiltr_suit">
          <div class="suitsfiltr_cards_title">
            {{ $t(`common.suited`) }}
          </div>
          <div class="suitsfiltr_cards_row">
            <div
              v-for="card in cards.suited"
              :key="card.value"
              class="mdi icon_btn suitsfiltr_cards_item suitsfiltr_suited"
              :data-tst="`suited_${card.value}`"
              :class="`
          ${isActive(card, 'suited', exclude) ? 'icon_btn_active suitsfiltr_cards_item_active' : ''}
          suit_${card.value} ${card.icon}${exclude ? '-outline' : ''}`"
              :style="`--clr-suit: var(${card.color})`"
              @click="setCard('suited', card.value)"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'
import { SNK } from '@/helpers/helpers'
import { getSuitsConf } from '@/helpers/constants'
import horizontalScroll_mix from '@/components/HorizolnalScroller/horizontalScroll_mix'

export default {
  name: 'StudyFilterSuits',
  components: {
    UnSwitcherNew,
  },
  mixins: [horizontalScroll_mix],
  props: {
    namespace: String,
    applyFilterActionName: { default: () => 'sol_data_applyFilter' },
  },
  data() {
    this.cardsConf = getSuitsConf()
    return {
      colorCodes: ['s', 'h', 'd', 'c'],
      exclude: false,
    }
  },
  methods: {
    isActive(card, key, exclude) {
      const suit = this.studySuits[`${exclude ? 'exclude_' : ''}${key}`] || ''
      return suit?.includes(card.value)
    },
    setIncex(value) {
      if (this.incex === value) return
      this.exclude = value === 'exclude'
    },
    setCard(id, value) {
      const idOne = `${this.exclude ? 'exclude_' : ''}${id}`
      const idTwo = `${this.exclude ? '' : 'exclude_'}${id}`
      const valuesOne = this.studySuits[idOne]
      const valuesTwo = this.studySuits[idTwo]
      const res = {
        ...this.studySuits,
        [idOne]: valuesOne.includes(value)
          ? valuesOne.filter(i => i !== value)
          : [...valuesOne, value],
        [idTwo]: valuesTwo.includes(value) ? valuesTwo.filter(i => i !== value) : valuesTwo,
      }
      this.$store.dispatch(SNK('sol_filters_apply', this.namespace), {
        key: 'suits',
        value: res,
        applyFilterActionName: this.applyFilterActionName,
      })
    },
  },
  computed: {
    studySuits() {
      return this.$store.getters[SNK('sol_filter_suits', this.namespace)]
    },
    incexOptions() {
      return [
        {
          value: 'include',
          text: this.$t('browse.include'),
        },
        {
          value: 'exclude',
          text: this.$t('browse.exlude'),
        },
      ]
    },
    cards() {
      const item = [this.cardsConf.s, this.cardsConf.h, this.cardsConf.d, this.cardsConf.c]
      return { suited: item, offsuited: item }
    },
  },
}
</script>

<style lang="scss" scoped>
.suitsfiltr_suited {
  position: relative;
  left: -0.1875rem;
  &:after {
    left: 0.1875rem;
  }
  text-shadow: 1px 0px 2px var(--clr-black-0), 0.375rem 0px 0px currentColor;
}
.suitsfiltr {
  display: flex;
  flex-direction: column;
  --clr-suitsfiltr-back: var(--clr-black-1-2);
  &_cards {
    display: flex;
    gap: 0.5rem;
    &:nth-child(2) {
      border-radius: 4px 4px 0px 0px;
    }
    &:nth-child(3) {
      border-radius: 0px 0px 4px 4px;
    }
    &_title {
      font-size: 0.7rem;
      font-weight: 700;
      text-transform: none;
      color: var(--clr-grey-2);
      margin: 0 auto 0 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    &_row {
      display: flex;
      margin: 0 0 0 auto;
      gap: 0.125rem;
    }
    &_item {
      font-size: 1.5rem;
      color: var(--clr-white-0);
      &_active {
        color: var(--clr-suit);
        --clr-back: var(--clr-suit);
        --after-opacity-active: 0.325;
        &.suit_h {
          filter: brightness(1.125);
        }
        &.suit_d {
          filter: brightness(1.25);
        }
        &.suit_s {
          filter: brightness(1.5);
        }
      }
    }
  }
}
</style>
